import React, { Component } from 'react';
import FormicaInput from '../../custom/FormicaInput';
import RoleHelper from '../../../RoleHelper';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState } from '../../../redux/store';
import { TrackerState } from '../../../redux/reducers/TrackerReducer';
import { changeTracker } from '../../../redux/actions/TrackerActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { TrackerTriggerTypeMobile } from '../../../domain/tracker/TrackerTriggerType';
import AnimatedButton from '../../custom/AnimatedButton';
import MessageUtil from '../../../util/MessageUtil';
import TriggerJsonModel from '../../../domain/tracker/trigger/TriggerJsonModel';
import CustomTable from '../../custom/CustomTable';
import { ColumnProps } from 'primereact/column';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import Icon from '../../../icons/Icon';
import TrackerTypeUtil from '../../../util/TrackerTypeUtil';
import TrackerSidebarComponent from './TrackerSidebarComponent';
import TrackerEventContentComponent from './TrackerEventContentComponent';
import ValueUtil from 'util/ValueUtil';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import LanguageUtil from '../../../util/LanguageUtil';

class TrackerEventComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const {
      tracker: { tracker },
    } = this.props;
    const { name, description, type, editorVisible, selectedData } = this.state;
    return (
      <div className={'flex flex-col w-full h-full px-5'}>
        <div className={'w-full flex flex-col lg:flex-row justify-around items-center mt-5 mb-3 gap-y-5 gap-x-5'}>
          <div className={'w-full flex'}>
            <FormicaInput
              onChange={this.onChangeName}
              value={name}
              name={'name'}
              label={LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
              type={'text'}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
          <div className={'w-full group flex gap-x-5 gap-y-5'}>
            <FormicaSearchSelectBox
              options={this.eventTypeOptions()}
              onChange={this.onChangeType}
              value={ValueUtil.convertEnumToString(type)}
              rounded={true}
              disabled={!RoleHelper.canEdit('Tracker')}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.type', defaultMessage: 'Type' })}
              label={LanguageUtil.get({ id: 'common.label.type', defaultMessage: 'Type' })}
            />
          </div>
          <div className={'w-full group flex gap-x-5 gap-y-5'}>
            <FormicaInput
              value={description}
              name={'Description'}
              onChange={this.onChangeDescription}
              type={'text'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
          <div className={'h-full flex justify-center items-center'}>
            <AnimatedButton
              text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
              customType={'primary'}
              customSize={'sm'}
              icon={'add'}
              onClick={this.addVariable}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
        </div>
        <div className={'flex items-center justify-center h-full !max-h-[calc(100vh-22rem)] scrollable-editor-container overflow-y-scroll'}>
          <CustomTable value={tracker.triggers} onRowClick={this.openEditor} columns={this.getColumns()} selectionMode={'single'} />
        </div>
        {editorVisible && <div className={'absolute top-0 left-0 w-full h-full bg-[#D9D9D94D]'}></div>}
        <TrackerSidebarComponent
          visible={editorVisible}
          icon={'add'}
          title={'Add a New Event'}
          closable
          onHide={this.closeEditor}
          content={
            <TrackerEventContentComponent
              selectedData={selectedData}
              setSelectedData={this.setSelectedData}
              onHide={this.closeEditor}
              visible={editorVisible}
            />
          }
        />
      </div>
    );
  }

  private onChangeName = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ name: e.currentTarget.value });
  };

  private onChangeType = (e: FormicaSelectBoxItem) => {
    this.setState({ type: e.value.name });
  };

  private onChangeDescription = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ description: e.currentTarget.value });
  };

  private eventTypeOptions = () => {
    const {
      tracker: { tracker },
    } = this.props;
    return TrackerTypeUtil.getEventTypeOptions(tracker.platform).map((option) => ({
      ...option,
      label: ValueUtil.convertEnumToString(option.label),
    }));
  };

  private addVariable = (): void => {
    const { name, description, type } = this.state;
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    if (tracker.stage != 'DRAFT') {
      MessageUtil.warning({
        summary: 'Tracker',
        content: 'Can not add trigger when tracker is deployed.',
      });
      return;
    }
    if (name == undefined || type == undefined) {
      return MessageUtil.warning({
        summary: 'Tracker',
        detail: <div>Name and type can not null</div>,
      });
    }
    if (tracker.triggers?.find((trigger: any) => trigger.name == name) != undefined) {
      return MessageUtil.warning({
        summary: 'Tracker',
        detail: <div>Trigger name already exist</div>,
      });
    }
    const trigger: TriggerJsonModel = {
      name: name.trim(),
      description: description || '',
      type: type,
      filters: [],
    };
    tracker.triggers.push(trigger);
    changeTracker(tracker);
    this.setState({ name: '', type: undefined, description: '' });
    return MessageUtil.success({
      summary: 'Tracker',
      detail: <div>Trigger created.</div>,
    });
  };

  private removeTrigger = (triggerToRemove: TriggerJsonModel): void => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    tracker.triggers = tracker.triggers.filter((trigger) => trigger !== triggerToRemove);
    changeTracker(tracker);
    MessageUtil.success({
      summary: 'Tracker',
      detail: <div>Trigger removed.</div>,
    });
  };

  private openEditor = (e: any) => {
    this.setState({
      selectedData: e.data,
      editorVisible: true,
    });
  };

  private closeEditor = () => {
    this.setState({
      editorVisible: false,
    });
  };

  private setSelectedData = (data: TriggerJsonModel) => {
    const {
      tracker: { tracker },
      changeTracker,
    } = this.props;
    const triggerIndex = tracker.triggers.findIndex((trigger) => trigger.name === this.state.selectedData?.name);
    if (triggerIndex === -1) return;
    tracker.triggers[triggerIndex] = data;
    this.setState({ selectedData: data });
    changeTracker(tracker);
  };

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'name',
        header: 'Name',
        className: 'w-1/4',
        body: (record: TriggerJsonModel) => {
          return <CustomTableContentWrapper text={record.name} />;
        },
      },
      {
        field: 'type',
        header: 'Type',
        className: 'w-1/4',
        body: (record: TriggerJsonModel) => {
          return <CustomTableContentWrapper text={ValueUtil.convertEnumToString(record.type)} />;
        },
      },
      {
        field: 'description',
        header: 'Description',
        className: 'w-1/4',
        body: (record: TriggerJsonModel) => {
          return <CustomTableContentWrapper text={record.description} />;
        },
      },
      {
        field: 'action',
        header: 'Action',
        className: 'max-w-[75px] 2xl:max-w-[100px]',
        alignHeader: 'center',
        sortable: false,
        body: (eventVariable: TriggerJsonModel) => {
          const disabled = !RoleHelper.canEdit('Tracker');
          return (
            <div
              className={'flex w-full h-full items-center justify-center'}
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                !disabled &&
                  customConfirm({
                    target: e.currentTarget,
                    accept: () => this.removeTrigger(eventVariable),
                    message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
                  });
              }}
            >
              <Icon
                icon={'delete'}
                size={20}
                color={'primary'}
                className={`hover:text-primary text-[#607080] ${disabled ? 'cursor-not-allowed' : 'hover:cursor-pointer'} flex items-center justify-center`}
              />
            </div>
          );
        },
      },
    ];
  };
}

class State {
  name: string | undefined;
  description: string | undefined;
  type: TrackerTriggerTypeMobile | undefined;
  editorVisible: boolean = false;
  selectedData: TriggerJsonModel | undefined;
}

interface Props extends FormicaProps, ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  tracker: state.tracker as TrackerState,
});

const mapDispatchToProps = {
  changeTracker,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(TrackerEventComponent));
